import { render, staticRenderFns } from "./pagesMenu.vue?vue&type=template&id=9623e3a8&lang=pug&"
import script from "./pagesMenu.vue?vue&type=script&lang=js&"
export * from "./pagesMenu.vue?vue&type=script&lang=js&"
import style0 from "./pagesMenu.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports